module.exports = __webpack_public_path__ + "static/media/ted.b8dbbf13.jpg";